<template>
    <div>
      <van-nav-bar
        title="资金明细"
        left-text="返回"
        left-arrow
        @click-left="$router.push('/member/members')"
        class=""
      />
      <van-tabs v-model="active" animated @click="getListLog">
        <van-tab v-for="(item,index) in title" :title=item :key="index" >
          <van-pull-refresh v-model="isLoading[index]" @refresh="onRefresh(active)">
            <van-loading v-if="showLoading" style="text-align: center;" />
            <van-cell-group>
              <van-cell v-for="(item1,index1) in listLog[index]" :key="index1">
                <template #title>
                  {{ item1.name }}
                </template>
                <template #label>
                  {{ item1.time }}
                </template>
                <template #default>
                  <div v-if="item1.number">
                    <span class="red" v-if="Number(item1.number) >= 0">{{ Number(item1.number).toFixed(2) }}元</span>
                    <span class="green" v-else>{{ Number(item1.number).toFixed(2) }}元</span>
                    <br>余额:{{ Number(item1.balance).toFixed(2) }}元
                  </div>
                </template>
              </van-cell>
            </van-cell-group>
          </van-pull-refresh>
        </van-tab>
      </van-tabs>
    </div>
</template>

<script>
    export default {
        name: "DetailedLog",
      data(){
          return{
            active:0,
            title:['全部明细','充值明细','提现明细','借款明细','利润提取','管理费用','代金券','赠返现金'],
            methods:['all_log','recharge_log','withdraw_log','loan_log','extract_log','manage_log','vouchermanage_log','give_back'],
            isLoading:[false,false,false,false,false,false,false,false],
            listLog:[
              [],[],[],[],[],[],[],[],
            ],
            showLoading:false,
          }
      },
      methods:{
        isLogin(){
          let that = this;
          if (!that.$store.state.loginType){
            that.$router.push('/login')
          }
       },
        getListLog(name){
          let that = this;
          if (that.listLog[name].length === 0){
            that.showLoading=true;
            if (name === 7){
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: 'all_log',
                  token: sessionStorage.getItem("token"),
                  type:14
                }
              })
                .then(function(res) {
                  that.showLoading=false;
                  let resData = res.data;
                  if (resData.code === 1) {
                    if (resData.data.length === 0){
                      that.addData(name,resData.data)
                    }else{
                      that.$set(that.listLog,name,resData.data);
                    }
                    // that.listLog[name] = resData.data;
                  } else if (resData.code === 0) {
                    that.$toast.fail(resData.msg);
                  }
                });
            }else{
              that.$http({
                url: "/",
                method: "post",
                data: {
                  nozzle: that.methods[name],
                  token: sessionStorage.getItem("token")
                }
              })
                .then(function(res) {
                  that.showLoading=false;
                  let resData = res.data;
                  if (resData.code === 1) {
                    switch (name) {
                      case 1:
                      case 2:
                        if (resData.data.data.length === 0){
                          that.addData(name,resData.data.data)
                        }else{
                          that.$set(that.listLog,name,resData.data.data);
                        }
                        break;
                      default:
                        if (resData.data.length === 0){
                          that.addData(name)
                        }else{
                          that.$set(that.listLog,name,resData.data);
                        }
                        break;
                    }
                  } else if (resData.code === 0) {
                    that.$toast.fail(resData.msg);
                  }
                });
            }
          }
        },
        addData(name,data){
          let that = this;
          that.$set(that.listLog,name,[{
            name: "暂无数据",
            number: "0",
            balance: "0",
            time: "暂无数据",
          }]);
        },
        onRefresh(name){
          let that = this;
          if (name === 7){
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: 'all_log',
                token: sessionStorage.getItem("token"),
                type:14
              }
            })
              .then(function(res) {
                let resData = res.data;
                that.isLoading[name] = false;
                if (resData.code === 1) {
                  if (resData.data.length === 0){
                    that.addData(name,resData.data)
                  }else{
                    that.$set(that.listLog,name,resData.data);
                  }
                  // that.listLog[name] = resData.data;
                } else if (resData.code === 0) {
                  that.$toast.fail(resData.msg);
                }
              });
          }else{
            that.$http({
              url: "/",
              method: "post",
              data: {
                nozzle: that.methods[name],
                token: sessionStorage.getItem("token")
              }
            })
              .then(function(res) {
                let resData = res.data;
                that.isLoading[name] = false;
                if (resData.code === 1) {
                  switch (name) {
                    case 1:
                    case 2:
                      if (resData.data.data.length === 0){
                        that.addData(name,resData.data.data)
                      }else{
                        that.$set(that.listLog,name,resData.data.data);
                      }
                      break;
                    default:
                      if (resData.data.length === 0){
                        that.addData(name)
                      }else{
                        that.$set(that.listLog,name,resData.data);
                      }
                      break;
                  }
                } else if (resData.code === 0) {
                  that.$toast.fail(resData.msg);
                }
              });
          }
        },
      },
      mounted:function () {
        this.isLogin();
        if(this.$route.params.tab){
          this.active = parseInt(this.$route.params.tab);
          this.getListLog(this.active);
        }else{
          this.getListLog(0);
        }
      },
    }
</script>

<style scoped>
  .red{
    color: red;
  }
  .green{
    color: green;
  }

  .navStyle{
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
  }
</style>



// WEBPACK FOOTER //
// src/components/DetailedLog.vue